import React from 'react';

export default function CTASection({ t }) {
  return (
    <section className="relative py-8 pb-8 md:py-20 md:pb-16 px-4 md:px-0 bg-[#181c24] text-white text-center overflow-hidden">
      <div className="absolute inset-0 bg-cover bg-center opacity-10" style={{ backgroundImage: 'url(/images/flowers2.jpg)' }}></div>
      <div className="absolute inset-0 bg-[#181c24] bg-opacity-90"></div>
      <div className="relative z-10 max-w-5xl mx-auto flex flex-col md:flex-row items-stretch justify-center gap-0 md:gap-0">
        {/* CTA */}
        <div className="flex-1 flex flex-col items-center justify-center text-center md:pr-12 py-8 md:py-0">
          <h2 className="text-3xl md:text-4xl font-playfair mb-4 text-[#f7e6df] font-semibold leading-tight">
            {t.cta.readyToBegin}
          </h2>
          <a 
            href="/contact" 
            className="border border-[#bfa76a] text-[#bfa76a] bg-transparent py-4 px-10 rounded-full text-lg font-semibold shadow-sm hover:bg-[#bfa76a] hover:text-[#181c24] transition-all duration-300 mb-4 text-center"
          >
            {t.cta.scheduleConsultation}
          </a>
          <p className="text-base text-[#f7e6df]/80 max-w-xs">{t.cta.consultationDetails}</p>
        </div>
      </div>
    </section>
  );
} 